module.exports = __webpack_public_path__ + "assets/img/picture3.e3191d05.png";